import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/messages';
import { translate } from 'containers/services/translate';
import { showmultipleJADDDecision } from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/utils';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Container } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';

export interface JudgementAddDocumentDecisionRecapProps {
  intl: IntlShape;
  judgementAddDocument: JudgementADDDocumentType;
}

const JudgementAddDocumentDecisionRecap: React.FC<JudgementAddDocumentDecisionRecapProps> = (
  props,
): JSX.Element => {
  const STATUS = {
    REJECTED: translate(messages.rejectedDecision, props),
    VALIDATED: translate(messages.validatedDecision, props),
    MODIFIED: translate(messages.validatedDecision, props),
  } as any;

  return (
    <Container>
      {showmultipleJADDDecision(props.judgementAddDocument) && (
        <section className="jadd-decision-recap-container">
          <div className="jadd-decision-recap">
            <h4 className="decision-recap-container-title">
              {translate(messages.courtManagerJudgementAddDecision, props)}
            </h4>
            &nbsp;
            <h4 className="decision-recap-container-status">
              <span>
                {STATUS[get(props, 'judgementAddDocument.status', '')]}
              </span>
            </h4>
          </div>
          {get(props, 'judgementAddDocument.status') ===
            PROCEDURE_STATUSES.REJECTED && (
            <div className="jadd-decision-recap">
              <article className="decision-status">
                <span className="decision-sub-bloc-title">
                  {translate(messages.rejectionReason, props)}
                </span>
                <span>
                  {get(props, 'judgementAddDocument.rejectionReason', '')}
                </span>
              </article>
            </div>
          )}
        </section>
      )}
    </Container>
  );
};

export default injectIntl(JudgementAddDocumentDecisionRecap);
